// @ts-nocheck
import React from "react";
import Dialog from '@mui/material/Dialog';
import {ModalTitle} from "../../../Componentes/feedback/dialog/ModalTitle";
import {DialogContent as ModalContent} from '@mui/material';
import { DialogActions as ModalActions } from '@mui/material';
import {TextFieldRojo} from "../../../App";
import {Button} from "@mui/material";
import { validate } from 'react-email-validator';
import AlertMessage from "../../../Alias/AlertMessage";
import {ConfirmationButton} from "../../../Componentes/inputs/ConfirmationButton";



export const EmailsModal = ({emails,setEmails,open,onClose}) => {
    const [lista, setLista] = React.useState({
        lista: '',
    })
    const [alertaSubmite,setAlertaSubmite] = React.useState(null)


    const validarEmails = () => {
        const emailsDeLista = lista.lista.split(',')

        if(emailsDeLista.every(validate)){
            setEmails(emailsDeLista.filter(email => !emails.includes(email)))
            onClose()
        }
        else setAlertaSubmite({status: 'error', message: 'Algun/os correos ingresados no son correctos' })
    }


    const handleChange = (prop) => (event) => {
        setLista({ ...lista, [prop]: event.target.value });
    };

    return (

        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="modal-agregar-lista"
            maxWidth="md"
            fullWidth
        >
            <ModalTitle id="modal-agregar-lista" onClose={onClose}>Agregar correos</ModalTitle>
                    <ModalContent dividers>
                        <AlertMessage alert={alertaSubmite} setAlert={setAlertaSubmite}/>
                        <TextFieldRojo
                            id="emails-lista"
                            label="Emails a añadir en la lista"
                            error={alertaSubmite ? alertaSubmite.status === 'error' : false}
                            value={lista.lista}
                            placeholder="Ingresar los correos separados por ','"
                            onChange={handleChange('lista')}
                            multiline
                            maxRows={8}
                            sx={{width: '100%'}}
                        /><br/><br/>
                    </ModalContent>
                    <ModalActions>
                        <ConfirmationButton onClick={() => validarEmails()} color="primary">Añadir Correos</ConfirmationButton>
                        <Button onClick={() => onClose()} >Cancelar</Button>
                    </ModalActions>
        </Dialog>

    );
};